module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-3.jpg?v=d0e4e424";